
import React from 'react';
import { Button } from '@/components/ui/button';
import { Shield, Wrench, Cloud, Briefcase, Building } from 'lucide-react';

// Category and industry subcategory type definitions
type Category = {
  id: string;
  name: string;
  icon: string | null;
  description?: string;
};

type IndustrySubcategory = {
  id: string;
  name: string;
  parentId: string;
  description?: string;
};

interface BlogCategoriesProps {
  selectedCategory: string;
  onSelectCategory: (categoryId: string) => void;
  selectedSubcategory: string | null;
  onSelectSubcategory: (subcategoryId: string) => void;
  categories: Category[];
  industrySubcategories: IndustrySubcategory[];
}

const BlogCategories: React.FC<BlogCategoriesProps> = ({
  selectedCategory,
  onSelectCategory,
  onSelectSubcategory,
  selectedSubcategory,
  categories,
  industrySubcategories
}) => {
  // Function to render the appropriate icon based on the icon name
  const renderIcon = (iconName: string | null) => {
    if (!iconName) return null;
    
    switch (iconName) {
      case 'Shield':
        return <Shield className="h-4 w-4" />;
      case 'Wrench':
        return <Wrench className="h-4 w-4" />;
      case 'Cloud':
        return <Cloud className="h-4 w-4" />;
      case 'Briefcase':
        return <Briefcase className="h-4 w-4" />;
      case 'Building':
        return <Building className="h-4 w-4" />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold mb-4">Categories</h2>
        <div className="space-y-2">
          {categories.map(category => (
            <Button
              key={category.id}
              variant={selectedCategory === category.id ? "default" : "ghost"}
              onClick={() => onSelectCategory(category.id)}
              className="w-full justify-start text-left"
            >
              {category.icon && <span className="mr-2">{renderIcon(category.icon)}</span>}
              {category.name}
            </Button>
          ))}
        </div>
      </div>
      
      {selectedCategory === "industry-specific" && (
        <div>
          <h3 className="text-lg font-medium mb-2">Industry Focus</h3>
          <div className="space-y-2 ml-4">
            {industrySubcategories.map(subcategory => (
              <Button
                key={subcategory.id}
                variant={selectedSubcategory === subcategory.id ? "secondary" : "ghost"}
                onClick={() => onSelectSubcategory(subcategory.id)}
                className="w-full justify-start text-left text-sm"
              >
                {subcategory.name}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogCategories;
